import _classCallCheck from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/skynet/Zhifan/repos/visualize-rotations/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import '../flags';
import { env } from '../environment';
import { BrowserIndexedDB, BrowserIndexedDBManager } from '../io/indexed_db';
import { BrowserLocalStorage, BrowserLocalStorageManager } from '../io/local_storage';
import { ModelStoreManagerRegistry } from '../io/model_management';
export var PlatformBrowser = /*#__PURE__*/function () {
  function PlatformBrowser() {
    _classCallCheck(this, PlatformBrowser);
    // For setTimeoutCustom
    this.messageName = 'setTimeoutCustom';
    this.functionRefs = [];
    this.handledMessageCount = 0;
    this.hasEventListener = false;
  }
  _createClass(PlatformBrowser, [{
    key: "fetch",
    value: function (_fetch) {
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }
      fetch.toString = function () {
        return _fetch.toString();
      };
      return fetch;
    }(function (path, init) {
      return fetch(path, init);
    })
  }, {
    key: "now",
    value: function now() {
      return performance.now();
    }
  }, {
    key: "encode",
    value: function encode(text, encoding) {
      if (encoding !== 'utf-8' && encoding !== 'utf8') {
        throw new Error("Browser's encoder only supports utf-8, but got ".concat(encoding));
      }
      if (this.textEncoder == null) {
        this.textEncoder = new TextEncoder();
      }
      return this.textEncoder.encode(text);
    }
  }, {
    key: "decode",
    value: function decode(bytes, encoding) {
      return new TextDecoder(encoding).decode(bytes);
    } // If the setTimeout nesting level is greater than 5 and timeout is less
    // than 4ms, timeout will be clamped to 4ms, which hurts the perf.
    // Interleaving window.postMessage and setTimeout will trick the browser and
    // avoid the clamp.
  }, {
    key: "setTimeoutCustom",
    value: function setTimeoutCustom(functionRef, delay) {
      var _this = this;
      if (typeof window === 'undefined' || !env().getBool('USE_SETTIMEOUTCUSTOM')) {
        setTimeout(functionRef, delay);
        return;
      }
      this.functionRefs.push(functionRef);
      setTimeout(function () {
        window.postMessage({
          name: _this.messageName,
          index: _this.functionRefs.length - 1
        }, '*');
      }, delay);
      if (!this.hasEventListener) {
        this.hasEventListener = true;
        window.addEventListener('message', function (event) {
          if (event.source === window && event.data.name === _this.messageName) {
            event.stopPropagation();
            var _functionRef = _this.functionRefs[event.data.index];
            _functionRef();
            _this.handledMessageCount++;
            if (_this.handledMessageCount === _this.functionRefs.length) {
              _this.functionRefs = [];
              _this.handledMessageCount = 0;
            }
          }
        }, true);
      }
    }
  }]);
  return PlatformBrowser;
}();
if (env().get('IS_BROWSER')) {
  env().setPlatform('browser', new PlatformBrowser());
  // Register LocalStorage IOHandler
  try {
    ModelStoreManagerRegistry.registerManager(BrowserLocalStorage.URL_SCHEME, new BrowserLocalStorageManager());
  } catch (err) {}
  // Register IndexedDB IOHandler
  try {
    ModelStoreManagerRegistry.registerManager(BrowserIndexedDB.URL_SCHEME, new BrowserIndexedDBManager());
  } catch (err) {}
}